module.exports = __webpack_public_path__ + "media/images/icons/vipio-logo-word-7bcb82a6ad3468fec49f2d2c28f469a3.svg";